var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page-sharer" },
    [
      _c(
        "dropdown",
        _vm._b(
          {
            attrs: {
              facets: ["sharer"],
              items: _vm.socials,
              "open-icon": _vm.openIcon,
              "closed-icon": _vm.closedIcon
            }
          },
          "dropdown",
          _vm.$attrs,
          false
        )
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2d4b1a28", { render: render, staticRenderFns: staticRenderFns })
  }
}